import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export default function Button({ btnLink, btnText, variant, icon }) {
  return (
    <Link
      to={btnLink}
      className={variant ? `_text_btn ${variant}` : '_text_btn'}
    >
      <>
        <span>{btnText}</span>
        {icon ? icon : <Icon icon="material-symbols:arrow-right-alt" />}
      </>
    </Link>
  );
}                      
